import React from 'react'
import styles from './ReplyArea.module.scss';
import formStyles from '../../common/ui/Form.module.scss';
import spinner from '../../common/ui/Spinner.module.scss';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import axios from 'axios';

const ReplyArea = (props) => {

  const location = useLocation();
  const params = qs.parse(location.search);

  const [value, setValue] = useState(props.initialValue || '');
  const [isFetching, setIsFetching] = useState();

  const handleInput = (e) => {
    setValue(e.target.value);
  }

  const submit = (e) => {
    if (isFetching) {
      return;
    }

    if (!value) {
      alert('내용을 입력해주세요.');
      return;
    }

    setIsFetching(true);
    if (props.isEdit){
      editReply();
    }
    else{
      writeReply();
    }
    
  }

  const writeReply = () => {
    const _params = { ...params };
    _params.command = 'write';
    _params.rootId = props.info.rootId;
    _params.parentId = props.info.parentId;

    axios.post('/api/reply/write?' + qs.stringify(_params), {
      content: value,
      writerId: props.profile.id,
      writerNickname: props.profile.nickname
    })
      .then((res) => {
        if (res.data.code === 500) {
          props.reFetchReplies(()=>{
            setValue('');
          });
        }
        else {
          alert('오류가 발생하였습니다.');
        }
      })
      .catch((err) => {
        alert('오류가 발생하였습니다.');
      })
      .finally(() => {
        setIsFetching(false);
      });
  }

  const editReply = () => {
    const _params = { ...params };
    _params.command = 'edit';
    _params.id = props.info.id;

    axios.post('/api/reply/write?' + qs.stringify(_params), {
      content: value,
    })
      .then((res) => {
        if (res.data.code === 500) {
          props.reFetchReplies(()=>{
            setValue('');
          });
        }
        else {
          alert('오류가 발생하였습니다.');
        }
      })
      .catch((err) => {
        alert('오류가 발생하였습니다.');
      })
      .finally(() => {
        setIsFetching(false);
      });
  }

  return (
    <div className={styles.wrapper_reply_area}>
      <div className={styles.container}>
      <div className={styles.content} style={{ ...props.style }}>
        {props.isLogin ?
          <p className={styles.nickname}>{props.profile.nickname}</p> :
          <p className={styles.disabled}>로그인 후 작성할 수 있습니다.</p>
        }
        {props.isLogin ?
          <textarea placeholder='내용을 입력해주세요.' onChange={handleInput} value={value || ''}></textarea> :
          <textarea disabled></textarea>
        }
        {props.canCancel && 
          <button className={formStyles.button} style={{right:'70px'}} onClick={()=>{props.cancelReply()}}><p>취소</p></button>
        }
        {props.isLogin ?
          <button className={formStyles.button} onClick={submit}><p>{props.isEdit ? '수정' : '등록'}</p></button> :
          <div className={styles.button_disabled}><p>{props.isEdit ? '수정' : '등록'}</p></div>
        }
      </div>
      </div>
    </div>
  )
}

export default ReplyArea